import { ComponentPropsWithoutRef } from 'react';
import { IonSegmentContent } from '@ionic/react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../../../../store/types';
import { REDUX_STORE_SLICES } from '../../../../../services/exports/Constants';

type ContactUsContentProps = ComponentPropsWithoutRef<typeof IonSegmentContent>;

const ContactUsContent = ({ className, ...rest }: ContactUsContentProps) => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Modals:HelpAndFaq:ContactUsContent' });
  const phoneNumber = useSelector(
    (state: StoreInterface) => state[REDUX_STORE_SLICES.INITIAL_DATA].company?.phone_number,
  );
  const email = useSelector((state: StoreInterface) => state[REDUX_STORE_SLICES.INITIAL_DATA].company?.email);
  const website = useSelector((state: StoreInterface) => state[REDUX_STORE_SLICES.INITIAL_DATA].company?.website_link);

  return (
    <IonSegmentContent className={classnames('space-y-8', className)} {...rest}>
      <section className="text-center">
        <address className="space-y-8">
          <p className="space-y-3">
            <span className="block text-xs font-medium text-brand-text-secondary">{t('talk_to_us')}</span>
            <a className="block text-sm font-semibold" href="tel:+491234567890">
              {phoneNumber}
            </a>
          </p>
          <p className="space-y-3">
            <span className="block text-xs font-medium text-brand-text-secondary">{t('send_us_email')}</span>
            <a className="block text-sm font-semibold" href={`mailto:${email}`}>
              {email}
            </a>
          </p>
          <p className="space-y-3">
            <span className="block text-xs font-medium text-brand-text-secondary">{t('visit_website')}</span>
            <a className="block text-sm font-semibold" href={website} target="_blank" rel="noopener noreferrer">
              {website}
            </a>
          </p>
        </address>
      </section>
      {/*<section className="text-center" id="community" aria-labelledby="community-heading">*/}
      {/*  <h2 className="text-xs font-semibold" id="community-heading">*/}
      {/*    {t('join_our_community')}*/}
      {/*  </h2>*/}
      {/*  <nav aria-label="Social media links" className="pt-md">*/}
      {/*    <ul className="flex align-center justify-center space-x-4">*/}
      {/*      <li>*/}
      {/*        <a href="https://facebook.com/pizzanostra" aria-label="Facebook">*/}
      {/*          <FacebookIcon />*/}
      {/*        </a>*/}
      {/*      </li>*/}
      {/*      <li>*/}
      {/*        <a href="https://instagram.com/pizzanostra" aria-label="Instagram">*/}
      {/*          <FacebookIcon />*/}
      {/*        </a>*/}
      {/*      </li>*/}
      {/*      <li>*/}
      {/*        <a href="https://x.com/pizzanostra" aria-label="X (formerly Twitter)">*/}
      {/*          <FacebookIcon />*/}
      {/*        </a>*/}
      {/*      </li>*/}
      {/*      <li>*/}
      {/*        <a href="https://pizzanostra.substack.com" aria-label="Substack">*/}
      {/*          <FacebookIcon />*/}
      {/*        </a>*/}
      {/*      </li>*/}
      {/*    </ul>*/}
      {/*  </nav>*/}
      {/*</section>*/}
    </IonSegmentContent>
  );
};

export default ContactUsContent;
